import api from '@/lib/api';
import type { Skill, CreateSkillDto, UpdateSkillDto } from '../types';

const BASE_URL = '/itc/skills';

/**
 * Skills API service
 */
export const skillsService = {
  /**
   * List all skills
   */
  async list(category?: string): Promise<Skill[]> {
    const params = category ? `?category=${encodeURIComponent(category)}` : '';
    const { data } = await api.get(`${BASE_URL}${params}`);
    return data;
  },

  /**
   * Get skill by ID
   */
  async getById(id: number): Promise<Skill> {
    const { data } = await api.get(`${BASE_URL}/${id}`);
    return data;
  },

  /**
   * Search skills by name
   */
  async search(query: string, limit: number = 20): Promise<Skill[]> {
    const { data } = await api.get(`${BASE_URL}/search?q=${encodeURIComponent(query)}&limit=${limit}`);
    return data;
  },

  /**
   * Create a new skill
   */
  async create(dto: CreateSkillDto): Promise<Skill> {
    const { data } = await api.post(BASE_URL, dto);
    return data;
  },

  /**
   * Update a skill
   */
  async update(id: number, dto: UpdateSkillDto): Promise<Skill> {
    const { data } = await api.patch(`${BASE_URL}/${id}`, dto);
    return data;
  },

  /**
   * Delete a skill
   */
  async delete(id: number): Promise<void> {
    await api.delete(`${BASE_URL}/${id}`);
  },

  /**
   * Get skill categories
   */
  async getCategories(): Promise<string[]> {
    const { data } = await api.get(`${BASE_URL}/categories`);
    return data;
  },
};
